// @ts-nocheck


import { fetchRequest } from './index';






import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (
washingCalculation) => (
{
  ...washingCalculation,
  sum: convertFromRubToKop(washingCalculation.sum),
  months: washingCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
washingCalculation) => (
{
  ...washingCalculation,
  sum: convertFromKopToRub(washingCalculation.sum),
  months: washingCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
washingCalculationMonth) => (
{
  ...washingCalculationMonth,
  cost: convertFromRubToKop(washingCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
washingCalculationMonth) => (
{
  ...washingCalculationMonth,
  cost: convertFromKopToRub(washingCalculationMonth.cost)
});

const basedUrl = 'washingCalculation';
const washingCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в мойке ТС',
  convertDataToServer,
  convertDataFromServer
);

export const updateCalculations = async (
vehiclePlanId) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось рассчитать`);
};

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

export default {
  ...washingCalculation,
  updateCalculations,
  calculate,
  changeStatus
};
